import { Environment } from '../utils/Environment';

//export const LOGIN_ROOT = `http://localhost:8000`;

 export const ACCESSDETAILS_API_ROOT = `${Environment.getAccessDetailsApiUrl()}`;

 export const LOGIN_ROOT = `${Environment.getLoginUrl()}`
// let locURL = (LOGIN_ROOT.includes(`dev`) || LOGIN_ROOT.includes(`localhost`)) ? `dev` : (LOGIN_ROOT.includes(`qa`) ? `qa` :
//     (LOGIN_ROOT.includes(`perf`) ? `perf` : (LOGIN_ROOT.includes(`acceptance`) ? `perf` : (LOGIN_ROOT.includes(`stage`) ? `perf` : `prod`))));


export const API_ROOT = `${Environment.getApiUrl()}`;
//export const ACCESSDETAILS_API_ROOT = `https://svwp-dashboard-service-westus-dev-app-service-route.apps.np.stratus.albertsons.com`;

export const apiUrl = {
    "testUrl": `https://jsonplaceholder.typicode.com/todos`,
}

export const getSubscriptionKey = {
    url: `${LOGIN_ROOT}/api/getSubKey`,
    method: `GET`
}

export const employeeDiscountValidationUrl = {
    "url": `${API_ROOT}/employees`,
    "methodType": `GET`,
}

export const employeeDiscountFormSubmitUrl = {
    "url": `${API_ROOT}`,
    "methodType": `POST`,
}

export const getAccessDetail = {
    url: `${ACCESSDETAILS_API_ROOT}/dashboard/getUserApplicationAccessDetails`,
    method: `POST`
}

export const zipCodeApiUrl = {
    "url": `${API_ROOT}/address?zipcode`,
    "methodType": `GET`,
}

export const cardNumberApiUrl = {
    "url": `${API_ROOT}/account`,
    "methodType": `POST`,
}

export const getOtpApiUrl = {
    "url": `${API_ROOT}/otp`,
    "methodType": `GET`,
}



